export enum LoginMethod {
  OIDC = 'OIDC',
  PASSWORD = 'PASSWORD',
}
